export const SMART_QR_TYPE_ID = {
  URL: 1,
  CONTACT: 2,
  WIFI: 3,
  CLIENT_SERVICES_CALL: 4,
  TEXT: 5,
  NAVIGATION: 6,
};
